import { render, staticRenderFns } from "./LoadingInfinity.vue?vue&type=template&id=172c54c8&scoped=true&"
import script from "./LoadingInfinity.vue?vue&type=script&lang=js&"
export * from "./LoadingInfinity.vue?vue&type=script&lang=js&"
import style0 from "./LoadingInfinity.vue?vue&type=style&index=0&id=172c54c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c54c8",
  null
  
)

export default component.exports